import script from "./Typifications.vue?vue&type=script&lang=ts&setup=true"
export * from "./Typifications.vue?vue&type=script&lang=ts&setup=true"

import "./Typifications.vue?vue&type=style&index=0&id=2891f4ce&lang=css"

const __exports__ = script;

export default __exports__